export const MAX_ALLOWED_DISTRIBUTIONS = 4;
